import { cartLineTotalTtc, type CartPricingItem } from './currency.js';

export {
  remainingQuantities,
  assertRefundQuantitiesAvailable,
} from './refund-quantities.js';
export type { RefundQuantityLine } from './refund-quantities.js';

function roundMillimes(n: number): number {
  return Math.round(n * 1000) / 1000;
}

/** Proportional share of the receipt line TTC. */
export function refundLineValue(item: CartPricingItem, qty: number): number {
  if (!(item.quantity > 0) || !(qty > 0)) return 0;
  const full = cartLineTotalTtc(item);
  return roundMillimes(full * (qty / item.quantity));
}

export function partialRefundNet(input: {
  returnValue: number;
  exchangeOutValue: number;
  replacementValue: number;
}): { net: number; refundAmount: number; collectedAmount: number } {
  const net = roundMillimes(
    input.returnValue + input.exchangeOutValue - input.replacementValue,
  );
  return {
    net,
    refundAmount: net > 0 ? net : 0,
    collectedAmount: net < 0 ? roundMillimes(-net) : 0,
  };
}
